import React from 'react';
import CardsPage from './CardsPage';
import alphabetData from '../Data/alphabetData';

function Qaida() {
    return <CardsPage data={alphabetData} />;
}

export default Qaida;
